import { gql } from '@apollo/client';
import { Client } from '../../fragments/client/client.fragments';
import { CommandeLine } from '../../fragments/commandeLine/commandeline.fragments';
import { Commande } from '../../fragments/commande/commande.fragments';
import { UserInfo } from '../../fragments/user/user.fragments';

export const CREATE_COMMANDE = gql`
  mutation AddCommandesAndNote($order: Order) {
    addCommandesAndNote(order: $order) {
      ...MainCommande
      user {
        data {
          attributes {
            ...PublicInfo
            classes {
              data {
                id
                attributes {
                  ...Classe
                }
              }
            }
          }
        }
      }
      commandelines {
        data {
          attributes {
            ...MainCommandeline
          }
        }
      }
      client {
        data {
          attributes {
            ...Main
          }
        }
      }
    }
  }
  ${Client.fragments.main}
  ${Commande.fragments.main}
  ${CommandeLine.fragments.mainCommandeLine}
  ${UserInfo.fragments.classe}
  ${UserInfo.fragments.publicInfo}
`;
